import { Injectable } from "@angular/core";
import { Actions, ofType, createEffect } from "@ngrx/effects";
import { switchMap, catchError, filter } from "rxjs/operators";
import { of } from "rxjs";
import { EventsService } from "@merchant_api/services/events.service";
import {
    ActionTypes,
    GetEventAction,
    GetEventFailAction,
    GetEventSucceedAction
} from "./event.actions";
import { GetEventDeliveriesAction, ResetEventDeliveriesAction } from "../event-deliveries/event-deliveries.actions";
import { RouterNavigationAction, ROUTER_NAVIGATED } from "@ngrx/router-store";
import { PageLoadFailAction } from "../router/router.actions";

@Injectable()
export class EventEffects {

    constructor(
        private actions: Actions,
        private eventsService: EventsService
    ) { }

    initEventPage = createEffect(() =>
        this.actions.pipe(
            ofType(ROUTER_NAVIGATED),
            filter((action: RouterNavigationAction) =>
                new RegExp(/dashboard\/developer\/webhooks\/event-history\/.+$/).test(action.payload.routerState.url)),
            switchMap((action: any) => {
                const rS = action.payload.routerState;
                const token = rS.root.firstChild.firstChild.params.id;
                return [new ResetEventDeliveriesAction(), new GetEventAction(token)];
            })
        )
    );

    getEvent = createEffect(() =>
        this.actions.pipe(
            ofType<GetEventAction>(ActionTypes.GetEvent),
            switchMap((action) =>
                this.eventsService.eventsGet({ token: action.token }).pipe(
                    switchMap((response) => of(new GetEventSucceedAction(response))),
                    catchError((error) => of(new GetEventFailAction(error)))
                )
            )
        ),
    );

    getEventSucceed = createEffect(() => this.actions.pipe(
        ofType<GetEventSucceedAction>(ActionTypes.GetEventSucceed),
        switchMap(action => [
            new GetEventDeliveriesAction(action.response.token, 1)
        ])
    ));

    getEventFail = createEffect(() =>
        this.actions.pipe(
            ofType<GetEventFailAction>(ActionTypes.GetEventFail),
            switchMap(() => of(PageLoadFailAction()))
        )
    );

}
